import { render, staticRenderFns } from "./PartnerAddress.vue?vue&type=template&id=103a67da&scoped=true"
import script from "./PartnerAddress.vue?vue&type=script&lang=js"
export * from "./PartnerAddress.vue?vue&type=script&lang=js"
import style0 from "./PartnerAddress.vue?vue&type=style&index=0&id=103a67da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103a67da",
  null
  
)

export default component.exports